import React from "react";

import "./Button.css";
import Icon from "../Icon";

export const Button = ({
  color = "blue",
  withIcon,
  iconVariant,
  forceActive,
  label,
  onClick,
}) => {
  const colorClass = `button-color--${color}`;
  const [iconColor, setIconColor] = React.useState(undefined);

  return (
    <div
      className={`button ${forceActive ? "active" : ""} ${colorClass} ${
        withIcon ? "with-icon" : ""
      }`}
      onClick={onClick}
      onMouseDown={() => setIconColor("white")}
      onMouseUp={() => setIconColor(undefined)}
    >
      <div className="button-label">
        <span className="button-label--text">{label}</span>
      </div>
      {withIcon ? (
        <div className="button-icon">
          <Icon
            color={forceActive ? "white" : iconColor}
            variant={iconVariant}
            size="xs"
          />
        </div>
      ) : null}
    </div>
  );
};
